// used in HtmlComment component
// see following URL for source credit
// https://github.com/Zneider/react-html-comment

import { useLayoutEffect as _useLayoutEffect, useEffect } from 'react';

const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? _useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
export const useLayoutEffect = useIsomorphicLayoutEffect